export default "__VITE_ASSET__BJU2FRo5__"